import React from 'react';
import moment from 'moment';
import { FORMAT_NUMBER, CURRENCY } from '../../libs/utils/Const';

export const renderAdminDeliveries20 = (headers, data, checkbox, openDetails) => {
    return renderTable(headers, data, checkbox, openDetails);
}

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%', textAlign: 'center' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td style={{ textAlign: 'center' }}>{headers[0].title}</td>}
            {headers[1].value && <td style={{ textAlign: 'center' }}>{headers[1].title}</td>}
            {headers[2].value && <td style={{ textAlign: 'center' }}>{headers[2].title}</td>}
            {headers[3].value && <td style={{ textAlign: 'center' }}>{headers[3].title}</td>}
            {headers[4].value && <td style={{ textAlign: 'center' }}>{headers[4].title}</td>}
            {headers[5].value && <td style={{ textAlign: 'center' }}>{headers[5].title}</td>}
            {headers[6].value && <td style={{ textAlign: 'center' }}>{headers[6].title}</td>}
            {headers[7].value && <td style={{ textAlign: 'center' }}>{headers[7].title}</td>}
            {headers[8].value && <td style={{ textAlign: 'center' }}>{headers[8].title}</td>}
            {headers[9].value && <td style={{ textAlign: 'center' }}>{headers[9].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};


const renderTableBody = (headers, data, checkbox, openDetails) => {
    let body = "";
    body = data.map((register, index) => {
        const fontColor = 'black'
        return (
            <tr key={index}>
                <td className="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>
                {headers[0].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register?.Code ?? ""}</td>}
                {headers[1].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register.TransferRoute != null ? 'Transferido' : register?.DocStatus === "O" ? 'Abierto' : 'Cerrado'}</td>}
                {headers[2].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register?.DocNum ?? "--"}</td>}
                {headers[3].value && <td style={{ color: fontColor, textAlign: 'center' }}>{moment(register?.DocDate).format("DD-MM-YYYY") ?? 'N/A'}</td>}
                {headers[4].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register?.PlacaVM ?? ""}</td>}
                {headers[5].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register?.Operador ?? ""}</td>}
                {headers[6].value && <td style={{ color: fontColor, textAlign: 'center' }}>{(CURRENCY + ' ' + FORMAT_NUMBER.new(register?.DocTotal ?? 0)) ?? "-"}</td>}
                {headers[7].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register?.U_FMB_AttentionType ?? ""}</td>}
                {headers[8].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register?.U_FMB_AttentionType === 'RUT' || register?.U_FMB_AttentionType?.toUpperCase() === 'RUTA' ? register?.Status ? 'Activo' : 'Inactivo' : "--"}</td>}
                {headers[9].value && <td style={{ color: fontColor, textAlign: 'center' }}>{register?.nombre ?? ""}</td>}
                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDetails({ Code: register.IdRTDOC, index })}
                        style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};


